<template>
<div class="modal_wrapper">
  <div class='container'>
    <div class='modal_container'>
      <div class="modal_header">
        <img :src='caution' height=25px>
        {{confirm}}
      </div>
      <div class="modal_body">
        <div class="body" v-html='text'>
        </div>
        <div class="modal_buttons">
          <input type=button :value='okButton' class="finish_button" @click="$emit('close')">
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      caution: require('../../../../img/caution.png'),
      confirm: '確認',
      okButton: 'OK'
    }
  },
  computed: {
    sysErrorMsg () {
      return this.$store.state.error.sysErrorMsg
    },
    text () {
      return this.sysErrorMsg.MSGCRD0069.name + this.sysErrorMsg.MSGCRD0069.value
    }
  }
}
</script>
<style scoped>
.modal_wrapper {
  background-color: rgba(0, 0, 0, .5);
}
.modal_container {
  width: 435px;
  height: 285px;
}
.container {
  display: table-cell;
  vertical-align: middle;
}
.body {
  width: 100%;
  height: 117px;
  padding-top: 40px;
}
.modal_header {
  background-color: #33CCFF;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/modalWindow/unauthorizedModalWindow.vue